import api from './client';

/**
 * Garmin Connect integration.
 *
 * Note what is NOT here: there is no "fetch my history" call. Garmin Starter
 * Access is push-only with no historical data, so the calendar is fed from
 * activities Garmin has already sent us, not from a query against Garmin.
 */

/** Connection state for the current user, for the Connected Accounts card. */
export const getGarminStatus = async () => {
  const response = await api.get('/integrations/garmin/status');
  return response.data;
};

/**
 * Start the OAuth flow. Returns the Garmin consent URL to send the user to.
 * @param {string|null} devRedirect admin-only: relay the code to a local server
 */
export const getGarminAuthUrl = async (devRedirect = null) => {
  const response = await api.get('/integrations/garmin/connect', {
    params: devRedirect ? { dev_redirect: devRedirect } : {},
  });
  return response.data.authorize_url;
};

/**
 * Staged activities for one sport over a date window.
 * @param {'run'|'bike'} sport
 * @param {string} start ISO date, inclusive
 * @param {string} end   ISO date, exclusive
 */
export const listGarminActivities = async (sport, start, end) => {
  const response = await api.get('/integrations/garmin/activities', {
    params: { sport, start, end },
  });
  return response.data;
};

/** Promote one staged activity into the user's files. */
export const importGarminActivity = async (activityId, description = null) => {
  const response = await api.post(
    `/integrations/garmin/activities/${activityId}/import`,
    { description },
  );
  return response.data;
};

/** Disconnect and erase everything we hold from this user's Garmin account. */
export const disconnectGarmin = async () => {
  const response = await api.delete('/integrations/garmin/disconnect');
  return response.data;
};
